export const CHARTS = 'CHARTS';
export const AUTH = 'AUTH';
export const EVENT = 'EVENT';
export const EVENTS = 'EVENTS';
export const USER = 'USER';
